import { https, httpsMultipart } from 'shared/utils/https';
import {
  IEditYapeQrRequestDTO,
  IYapePromotionListParamsDTO,
  IYapePromotionListResponseDTO,
  IYapePromotionReportParamsDTO,
  IYapePromotionReportResponseDTO,
  IYapeQrListParamsDTO,
  IYapeQrListResponseDTO,
} from './yape.dto';

const yapeEntitiesBaseURL = '/v1';

export const yapeData = {
  getYapePromotionList: async (params: IYapePromotionListParamsDTO): Promise<IYapePromotionListResponseDTO> => {
    const url = `${yapeEntitiesBaseURL}/yape/promotions`;
    const { data } = await https.get<IYapePromotionListResponseDTO>(url, { params });
    return data;
  },
  createYapePromotion: async (body: FormData): Promise<void> => {
    const url = `${yapeEntitiesBaseURL}/yape/promotions`;
    const { data } = await httpsMultipart.post(url, body);
    return data;
  },
  editYapePromotion: async (body: FormData, id: number): Promise<void> => {
    const url = `${yapeEntitiesBaseURL}/yape/promotions/${id}`;
    const { data } = await httpsMultipart.patch(url, body);
    return data;
  },
  deleteYapePromotion: async (id: number): Promise<void> => {
    const url = `${yapeEntitiesBaseURL}/yape/promotions/${id}`;
    const { data } = await https.delete(url);
    return data;
  },
  getYapePromotionReports: async (
    params: IYapePromotionReportParamsDTO,
    id: number,
  ): Promise<IYapePromotionReportResponseDTO> => {
    const url = `${yapeEntitiesBaseURL}/yape/promotions/${id}/reports`;
    const { data } = await https.get(url, { params });
    return data;
  },
  getYapeQrList: async (params: IYapeQrListParamsDTO, id: number): Promise<IYapeQrListResponseDTO> => {
    const url = `${yapeEntitiesBaseURL}/yape/promotions/${id}/codes`;
    const { data } = await https.get<IYapeQrListResponseDTO>(url, { params });
    return data;
  },
  editYapeQr: async (body: IEditYapeQrRequestDTO, yapePromoId: number, yapeQrId: number): Promise<void> => {
    const url = `${yapeEntitiesBaseURL}/yape/promotions/${yapePromoId}/codes/${yapeQrId}`;
    const { data } = await https.patch(url, body);
    return data;
  },
};
